import { render, staticRenderFns } from "./statusRank.vue?vue&type=template&id=6a13978d&scoped=true"
import script from "./statusRank.vue?vue&type=script&lang=js"
export * from "./statusRank.vue?vue&type=script&lang=js"
import style0 from "./statusRank.vue?vue&type=style&index=0&id=6a13978d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13978d",
  null
  
)

export default component.exports